<template>
  <div id="report-my">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-result.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <div class="report-text">
              <h1>{{ $t('report.title') }}</h1>
              <p>{{ $t('report.content') }}</p>
            </div>
            <div class="report-chart">
              <comp-chart-radar :data="chartData" v-if="isLoaded"></comp-chart-radar>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <div class="role-detail">
              <h4>
                <i class="fas fa-lightbulb"></i>
                {{ $t('report.ideation.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == ideation }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.ideation.content') }}</p>
            </div>
            <div class="role-detail">
              <h4>
                <i class="fas fa-expand-arrows-alt"></i>
                {{ $t('report.multiplier.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == multiplier }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.multiplier.content') }}</p>
            </div>
            <div class="role-detail">
              <h4>
                <i class="fas fa-stream"></i>
                {{ $t('report.solution.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == solution }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.solution.content') }}</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <div class="role-detail">
              <h4>
                <i class="fas fa-check-circle"></i>
                {{ $t('report.judgement.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == judgement }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.judgement.content') }}</p>
            </div>
            <div class="role-detail">
              <h4>
                <i class="fas fa-angle-double-right"></i>
                {{ $t('report.execution.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == execution }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.execution.content') }}</p>
            </div>
            <div class="role-detail">
              <h4>
                <i class="fas fa-comments"></i>
                {{ $t('report.critic.title') }}
              </h4>
              <div class="role-stat">
                <span
                  :class="['lv' + (index + 1), { active: index == critic }]"
                  v-for="(item, index) in roleItems"
                  :key="index">
                  {{item}}
                </span>
              </div>
              <p>{{ $t('report.critic.content') }}</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>

</template>

<script>
import common from '@/utils/common';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import CompHeader from '@/components/CompHeader';
import CompChartRadar from '@/components/CompChartRadar';
import RESPONSE from '@/constants/response';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'report-my',
  mixins: [
    common,
  ],
  components: {
    swiper,
    swiperSlide,
    CompHeader,
    CompChartRadar,
    CompLoading,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.btn-next',
        },
      },
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('report.roleHeader'),

      chartData: {
        labels: [
          this.$i18n.t('report.ideation.short'),
          this.$i18n.t('report.multiplier.short'),
          this.$i18n.t('report.solution.short'),
          this.$i18n.t('report.judgement.short'),
          this.$i18n.t('report.execution.short'),
          this.$i18n.t('report.critic.short'),
        ],
        datasets: [
          {
            data: [60, 60, 60, 30, 60, 60],
            borderColor: '#007aff',
            backgroundColor: 'RGBA(0, 122, 255, 0.6)',
            pointBackgroundColor: '#007aff',
            pointBorderColor: '#007aff',
          },
        ],
      },

      roleItems: [
        this.$i18n.t('report.veryBad'),
        this.$i18n.t('report.bad'),
        this.$i18n.t('report.soso'),
        this.$i18n.t('report.good'),
        this.$i18n.t('report.veryGood'),
      ],
      ideation: 0,
      multiplier: 0,
      solution: 0,
      judgement: 0,
      execution: 0,
      critic: 0,
      isLoaded: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,

      isLoading: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    getMyRole() {
      this.isLoading = true;

      this.$store.dispatch('getMyTeamRole')
        .then(({ status, data }) => {
          if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getMyRole();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (status === RESPONSE.SUCCESS.CODE) {
            // 차트 데이터
            this.chartData.datasets[0].data = [
              data.ideation,
              data.multiplier,
              data.solution,
              data.judgement,
              data.execution,
              data.advocate,
            ];
            this.isLoaded = true;

            // 각각 아이템 값 세팅
            this.ideation = this.getMyRoleItem(data.ideation);
            this.multiplier = this.getMyRoleItem(data.multiplier);
            this.solution = this.getMyRoleItem(data.solution);
            this.judgement = this.getMyRoleItem(data.judgement);
            this.execution = this.getMyRoleItem(data.execution);
            this.critic = this.getMyRoleItem(data.advocate);
          }
          this.isLoading = false;
        });
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  created() {
    this.getMyRole();
  },
  mounted() {
    this.isShowMenu(false);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/report-role.scss"></style>



// WEBPACK FOOTER //
// src/views/report/report-role.vue